'use client';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import Hero from './_components/Hero';
import ProfileList from './_components/ProfileList';
import { profilesRows } from './_data/profiles';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="leadership-page">
      <Hero />
      <ProfileList profileRows={profilesRows} />
    </div>
  );
};

export default Content;
